<template>
	<div>
		<div class="row">
			<div class="col-5 mb-4">
				<h1>{{ $t("learning-outcomes-report") }}</h1>
			</div>
			<div class="col-7 mb-4">
				<button
                    class="btn btn-outline-secondary ml-2 float-lg-right float-left"
                    :title="$t('download')"
                    @click="getCSV()"
                    :disabled="selected_outcome_groups.length == 0"
                >
                    <b-icon-download />
                </button>
			</div>
		</div>
        <div class="row">
            <div class="col-12">
                <CheckboxInput
                    v-for="outcome_group in outcome_groups"
                    :key="outcome_group.id"
                    :label="outcome_group.title"
                    @input="toggleOutcomeGrp(outcome_group)"
                >
                    <template v-slot:label>
                        <span class="font-weight-bold">{{ outcome_group.title }}</span>
                    </template>
                    <template v-slot:footer>
                        {{ outcome_group.note }}
                    </template>
                </CheckboxInput>
            </div>
        </div>
        <div class="list-group border-radius-2 no-border" v-if="selected_outcome_groups.length>0">
            <div class="list-group-item">
                <div class="row mb-1" v-for="(outcome_group,index) in selected_outcome_groups" :key="index">
                    <div class="col-12" v-if="loaded_group[outcome_group.id]">
                        <div class="card">
                            <h2 class="card-header">{{ outcome_group.title }}</h2>
                            <div class="card-body">
                                <p v-if="outcome_group.note">
                                    <strong>{{  $t('notes') }}: </strong>{{ outcome_group.note }}
                                </p>
                                <div class="row">
                                    <b-list-group>
                                        <b-list-group-item v-for="LO in outcome_group.learningoutcomes" :key="LO.id">
                                            {{ LO.title }}
                                            <b-list-group>
                                                <b-list-group-item v-for="node in LO.curriculummap" :key="node.id">
                                                    {{ node.path }}
                                                </b-list-group-item>
                                            </b-list-group>
                                        </b-list-group-item>
                                    </b-list-group>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--table v-else class="table">
                        <tr v-for="item in Array(5)" v-bind:key="item">
                            <td>
                                <div class="skeleton midnight h16 w-half"></div>
                            </td>
                        </tr>
                    </table-->
                </div>
            </div>
		</div>
	</div>
</template>

<script>
import Papa from 'papaparse';

export default {

	data: function () {
		return {
            outcome_groups: [],
            showDeleteButton: {},
            loaded: false,
            selected_outcome_groups:[],
            loaded_group:{},
            all_nodes:[]
		};
	},
	mounted() {
        this.getOutcomesGroups();
        this.getNodes();
	},
	methods: {
		getOutcomesGroups() {
            this.$cfetch(`${this.$settings.APIBaseURL}/learningoutcome/group/list`, {
                    method: 'post'
            }).then((res) => {
                if (res.status === "SUCCESS") {
                    this.outcome_groups = res.results;
                    this.outcome_groups_titles = this.outcome_groups.map(x => {return x.title;})
                    this.loaded = true;
                }
                else {
                    console.log(`Not downloaded`)
                }
            });
		},
        toggleOutcomeGrp(outcome_group) {
            const index = this.selected_outcome_groups.findIndex(item => item.id == outcome_group.id);
            if (index > -1) {
                this.selected_outcome_groups.splice(index, 1);
                this.loaded_group[outcome_group.id] = false;
            } else {
                this.getLearningOutcomeGroup(outcome_group.id)
            }
        },
        getLearningOutcomeGroup(id){
            this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/getreport`, {
                    method: 'post',
                    data: {
                        id:id
                    }
            }).then((res) => {
                if (res.status === "SUCCESS") {
                    this.selected_outcome_groups.push(res.result);
                    this.loaded_group[res.result.id] = true;
                }
                else {
                    console.log(`Could not fetch outcome group`)
                }
            });
        },
        getNodes(){
            this.$cfetch(`${this.$settings.APIBaseURL}/curriculummap/listnodes`, {
                method: 'post',
                data: {
                    string: true,
                    all_nodes: true
                }
            }).then((res) => {
                if (res.status === "SUCCESS") {
                    if(res.results) this.all_nodes = res.results;
                }
                else {
                    console.log(`Not loaded`);
                }
            });
        },
        createReport(){
            const user_selection = this.selected_outcome_groups.flatMap(x =>{
                let rows = [];

                // Set headers
                const learning_outcomes_group = {
                    'Learning Outcome Group' : x.title,
                    //'Learning Outcome Group Notes': x.note,
                    'Learning Outcome' : null,
                    //'Learning Outcome Note' : null,
                    'Path': null
                };
                rows.push(learning_outcomes_group);
                // We loop through each learning outcome
                Object.keys(x.learningoutcomes).forEach(key => {
                    const lo = x.learningoutcomes[key]
                    // Some formatting
                    const code = lo.code ? `${lo.code}:` : '';
                    const learningoutcome = `${code} ${lo.title}`;

                    // Generate a row, notice LO Group is null
                    const learning_outcomes = {
                        'Learning Outcome Group' : null,
                        //'Learning Outcome Group Notes': null,
                        'Learning Outcome' : learningoutcome,
                        //'Learning Outcome Note' : y.note,
                        'Path': null
                    }

                    rows.push(learning_outcomes);

                    // Finally, we loop over nodes
                    //lo.curriculummap.forEach( z => {
                    Object.keys(lo.curriculummap).forEach( key => {
                        const entry = lo.curriculummap[key]
                        const node = {
                            'Learning Outcome Group' : null,
                            //'Learning Outcome Group Notes': null,
                            'Learning Outcome' : null,
                            //'Learning Outcome Note' : null,
                            'Path': entry.path
                        }

                        rows.push(node);
                    })
                });

                return rows;
            });
            return user_selection;
        },
        getCSV(){
            let report = this.createReport();
            // Get the CSV via a Promise
            return new Promise((resolve, reject) => {
                try {
                    const csv = Papa.unparse(report);
                    resolve(csv);
                } catch (error) {
                    console.error('Error unparsing CSV file:', error);
                    reject(error);
                }
            }).then(res => {
                // Create a Blob from the CSV string
                const blob = new Blob([res], { type: 'text/csv' });

                // Give it a download link
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `learning_outcomes_report.csv`;

                // Trigger download
                a.click();

                // Housekeeping
                URL.revokeObjectURL(url);
            });
        }
	},
    computed:{
       selectedOutcomeGroups(){
            if(this.selected_outcome_groups.length>0) {
                return this.outcome_groups.filter(x =>  this.selected_outcome_groups.includes(x.title));
            }
            return [];
        }
    }
};
</script>
